import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CartProvider } from "./contexts/CartContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NeuralWeaveBackground from "./components/NeuralWeaveBackground";
import Home from "./pages/Home";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import PortalDashboard from "./pages/portal/PortalDashboard";
import NewQuoteRequest from "./pages/portal/NewQuoteRequest";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminServices from "./pages/admin/AdminServices";
import AdminCareerJobs from "./pages/admin/AdminCareerJobs";
import AdminReferences from "./pages/admin/AdminReferences";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminPromoCodes from "./pages/admin/AdminPromoCodes";
import DomainSearchPage from "./pages/DomainSearch";
import Solutions from "./pages/Solutions";
import SolutionDetail from "./pages/SolutionDetail";
import References from "./pages/References";
import ReferenceDetail from "./pages/ReferenceDetail";
import { Careers, CareerDetail } from "./pages/Careers";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Basket from "./pages/Basket";
import Checkout from "./pages/Checkout";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <CartProvider>
          <NotificationProvider>
            <BrowserRouter>
              {/* Global Neural Weave Background - Fixed at lowest z-index */}
              <NeuralWeaveBackground />

              <div className="min-h-screen flex flex-col relative z-10">
                <Routes>
                  {/* Auth routes without header/footer */}
                  <Route path="/auth/login" element={<Login />} />
                  <Route path="/auth/register" element={<Register />} />

                  {/* Admin routes with header only */}
                  <Route path="/admin/*" element={
                    <>
                      <Header />
                      <main className="flex-grow pt-16">
                        <Routes>
                          <Route path="/" element={<AdminDashboard />} />
                          <Route path="/quotes" element={<AdminQuotes />} />
                          <Route path="/services" element={<AdminServices />} />
                          <Route path="/career-jobs" element={<AdminCareerJobs />} />
                          <Route path="/references" element={<AdminReferences />} />
                          <Route path="/contacts" element={<AdminContacts />} />
                          <Route path="/promo-codes" element={<AdminPromoCodes />} />
                        </Routes>
                      </main>
                    </>
                  } />

                  {/* Portal routes with header only */}
                  <Route path="/portal/*" element={
                    <>
                      <Header />
                      <main className="flex-grow pt-16">
                        <Routes>
                          <Route path="/" element={<PortalDashboard />} />
                          <Route path="/new-quote" element={<NewQuoteRequest />} />
                        </Routes>
                      </main>
                    </>
                  } />

                  {/* Public routes with header and footer */}
                  <Route path="/*" element={
                    <>
                      <Header />
                      <main className="flex-grow pt-16">
                        <Routes>
                          <Route path="/" element={<Home />} />
                          <Route path="/solutions" element={<Solutions />} />
                          <Route path="/solutions/:slug" element={<SolutionDetail />} />
                          <Route path="/references" element={<References />} />
                          <Route path="/references/:slug" element={<ReferenceDetail />} />
                          <Route path="/about" element={<About />} />
                          <Route path="/careers" element={<Careers />} />
                          <Route path="/careers/:slug" element={<CareerDetail />} />
                          <Route path="/contact" element={<Contact />} />
                          <Route path="/domain-search" element={<DomainSearchPage />} />
                          <Route path="/basket" element={<Basket />} />
                          <Route path="/checkout" element={<Checkout />} />
                          <Route path="/privacy" element={<Privacy />} />
                          <Route path="/terms" element={<Terms />} />
                          <Route path="/refund" element={<Refund />} />
                        </Routes>
                      </main>
                      <Footer />
                    </>
                  } />
                </Routes>
              </div>
            </BrowserRouter>
          </NotificationProvider>
        </CartProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
